<div class="row m-0 footer py-4">
    <p class="mb-0 text-center">
        Copyright © 2024 Stanley Black & Decker, Inc. All rights reserved.
    </p>
</div>